
export function login(fetch, dados) {
  return fetch().post("/auth/login", dados);
}

export function register(fetch, dados) {
  return fetch().post("", { rota: "/cadastrar", ...dados });
}